export const countActiveFields = (fieldsArray) => {
  let iterator = 0;
  fieldsArray.forEach((field) => {
    if (typeof field === "number") iterator += field;
    else if (field) iterator += 1;
  });
  return iterator;
};
